// extracted by mini-css-extract-plugin
module.exports = {"admin":"admin_admin__iiFgT","button":"admin_button__1do7-"};